<template>
    <div
        class="expenses-detail-visualization"
        v-loading="loading"
        element-loading-spinner="presupuesto-loader"
    >
        <div class="row">
            <div class="col-sm-8"></div>
            <div class="col-sm-4">
                <div class="text-right">
                    <el-input
                        prefix-icon="el-icon-search"
                        placeholder="Buscar..."
                        v-model="search"
                        clearable
                    ></el-input>
                </div>
            </div>
        </div>
        <br />
        <el-table
            :data="data"
            stripe
            :height="height"
            @sort-change="sortChange"
        >
            <el-table-column prop="nombre_area" label="Area" sortable="custom">
                <template slot-scope="scope">
                    <a
                        :href="
                            '/institutions/' +
                                scope.row.partida +
                                '/' +
                                scope.row.capitulo +
                                '/' +
                                scope.row.area
                        "
                        >{{ scope.row.nombre_area }}</a
                    >
                </template>
            </el-table-column>
            <el-table-column
                prop="nombre_beneficiario"
                label="Receptor"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.intraestado">{{
                        scope.row.nombre_beneficiario
                    }}</span>
                    <a v-else :href="'/providers/' + scope.row.beneficiario">{{
                        scope.row.nombre_beneficiario
                    }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="beneficiario" label="RUT" sortable="custom">
                <template slot-scope="scope">{{
                    scope.row.beneficiario !== null && !scope.row.persona
                        ? rutFormatter(scope.row.beneficiario)
                        : 'No disponible'
                }}</template>
            </el-table-column>
            <el-table-column
                prop="tipo_documento"
                label="Tipo de Documento"
                sortable="custom"
            >
                <template slot-scope="scope"
                    >{{ scope.row.tipo_documento }}
                    {{
                        scope.row.numero_documento
                            ? 'Nº ' + scope.row.numero_documento
                            : ''
                    }}</template
                >
            </el-table-column>
            <el-table-column
                prop="fecha_documento"
                label="Fecha Documento"
                sortable="custom"
            >
                <template slot-scope="scope">{{
                    scope.row.fecha_documento !== null
                        ? moment(scope.row.fecha_documento).format('DD/MM/YYYY')
                        : 'No disponible'
                }}</template>
            </el-table-column>
            <el-table-column
                prop="fecha_pago"
                label="Fecha Pago"
                sortable="custom"
            >
                <template slot-scope="scope">{{
                    scope.row.fecha_pago !== null
                        ? moment(scope.row.fecha_pago).format('DD/MM/YYYY')
                        : isFloatingDebt(scope.row)
                        ? 'Traspasado a DF'
                        : 'No disponible'
                }}</template>
            </el-table-column>
            <el-table-column
                label="Monto Devengado"
                prop="devengo"
                sortable="custom"
                class-name="amount"
                width="140"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <div>
                        {{ numeral(scope.row.devengo_original).format('$0,0') }}
                        {{ formatCurrency(scope.row.moneda) }}
                        {{
                            scope.row.devengo_original !==
                            scope.row.monto_original
                                ? '*'
                                : ''
                        }}
                        {{ isFloatingDebt(scope.row) ? '#' : '' }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="Orden de Compra">
                <template slot-scope="scope">
                    <template v-if="checkOC(scope.row.orden_de_compra)">
                        <a
                            v-if="!scope.row.bloqueo_oc"
                            href="#"
                            @click.prevent="openOC(scope.row.orden_de_compra)"
                            >{{ scope.row.orden_de_compra }}</a
                        >
                        <span
                            v-else
                            v-tippy="{
                                html: '#tooltip-blocked-oc',
                                interactive: true
                            }"
                            >{{ scope.row.orden_de_compra }}</span
                        >
                        <div id="tooltip-blocked-oc" class="d-none">
                            Esta OC no es desplegada porque este servicio podría
                            haber incluido datos personales protegidos por la
                            Ley de Protección de la Vida Privada Nº19.628
                        </div>
                    </template>
                    <span
                        v-else
                        v-tippy="{ html: '#tooltip-oc', interactive: true }"
                        >{{
                            scope.row.orden_de_compra || 'No disponible'
                        }}</span
                    >
                    <div id="tooltip-oc" class="d-none">
                        No se puede encontrar el archivo. Puedes solicitarlo en
                        el portal de transparencia de esta institución
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <br />
        <div class="text-center">
            <el-pagination
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
            ></el-pagination>
        </div>
        <br />
        <div class="text-right disclaimer">
            * Documento presenta pago parcial o documento no se encuentra pagado
            en un 100%.
        </div>
        <div class="text-right disclaimer">
            # Documento no pagado durante el año de ejecución presupuestaria,
            traspasado a deuda flotante.
        </div>
        <div class="text-right mt-4">
            <a :href="downloadURL" class="download-link" target="_blank">
                <i class="material-icons">get_app</i>Descargar data desagregada
            </a>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <div v-loading="dialogOCLoading">
                <template v-if="dialogOCError">
                    <p>{{ dialogOCError }}</p>
                </template>
                <template v-if="dialogOC">
                    <template v-for="d in dialogOC.Listado">
                        <div class="row">
                            <div class="col-sm-8">
                                <div class="label">Nombre</div>
                                <div class="name">{{ d.Nombre }}</div>
                            </div>
                            <div class="col-sm-2">
                                <div class="label">Fecha de envío OC</div>
                                <div>
                                    {{
                                        moment(d.Fechas.FechaEnvio).format(
                                            'DD/MM/YYYY'
                                        )
                                    }}
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="label">Estado</div>
                                <div>{{ d.Estado }}</div>
                            </div>
                        </div>

                        <br />

                        <div class="label">Descripción</div>
                        <div>{{ hideRUT(d.Descripcion) }}</div>

                        <br />

                        <table class="table table-bordered">
                            <tr>
                                <td>
                                    <div class="label">Comprador</div>
                                    <div>{{ d.Comprador.NombreOrganismo }}</div>

                                    <br />

                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div class="label">
                                                Unidad Compradora
                                            </div>
                                            <div>
                                                {{ d.Comprador.NombreUnidad }}
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="label">
                                                Dirección Compradora
                                            </div>
                                            <div>
                                                {{
                                                    d.Comprador.DireccionUnidad
                                                }}
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="label">Contacto OC</div>
                                            <div>
                                                {{ d.Comprador.NombreContacto }}
                                                /
                                                {{ d.Comprador.FonoContacto }} /
                                                {{ d.Comprador.MailContacto }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="label">Proveedor</div>
                                    <div>{{ d.Proveedor.Nombre }}</div>

                                    <br />

                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div class="label">RUT</div>
                                            <div>
                                                {{ d.Proveedor.RutSucursal }}
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="label">
                                                Dirección Proveedor
                                            </div>
                                            <div>
                                                {{ d.Proveedor.Direccion }}
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="label">Contacto OC</div>
                                            <div>
                                                {{ d.Proveedor.NombreContacto }}
                                                /
                                                {{ d.Proveedor.FonoContacto }} /
                                                {{ d.Proveedor.MailContacto }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>

                        <br />
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Código/Id Licitación CM</th>
                                        <th>Producto / Servicio</th>
                                        <th>Cant.</th>
                                        <th>Especificaciones Comprador</th>
                                        <th>Especificaciones Proveedor</th>
                                        <th>Precio Unitario</th>
                                        <th>Descuento</th>
                                        <th>Cargos</th>
                                        <th>Impuestos</th>
                                        <th>Valor Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="i in d.Items.Listado">
                                        <td>{{ i.CodigoProducto }}</td>
                                        <td>{{ i.Producto }}</td>
                                        <td>{{ i.Cantidad }}</td>
                                        <td>
                                            {{
                                                hideRUT(
                                                    i.EspecificacionComprador
                                                )
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                hideRUT(
                                                    i.EspecificacionProveedor
                                                )
                                            }}
                                        </td>
                                        <td>
                                            {{ i.Moneda }}
                                            {{
                                                numeral(i.PrecioNeto).format(
                                                    '0,0.[00]'
                                                )
                                            }}
                                        </td>
                                        <td>
                                            {{ i.Moneda }}
                                            {{
                                                numeral(
                                                    i.TotalDescuentos
                                                ).format('0,0.[00]')
                                            }}
                                        </td>
                                        <td>
                                            {{ i.Moneda }}
                                            {{
                                                numeral(i.TotalCargos).format(
                                                    '0,0.[00]'
                                                )
                                            }}
                                        </td>
                                        <td>
                                            {{ i.Moneda }}
                                            {{
                                                numeral(
                                                    i.TotalImpuestos
                                                ).format('0,0.[00]')
                                            }}
                                        </td>
                                        <td>
                                            {{ i.Moneda }}
                                            {{
                                                numeral(i.Total).format(
                                                    '0,0.[00]'
                                                )
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right" colspan="6">
                                            Neto
                                        </td>
                                        <td class="text-right" colspan="4">
                                            {{ d.TipoMoneda }}
                                            {{
                                                numeral(d.TotalNeto).format(
                                                    '0,0.[00]'
                                                )
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right" colspan="6">
                                            Dcto
                                        </td>
                                        <td class="text-right" colspan="4">
                                            {{ d.TipoMoneda }}
                                            {{
                                                numeral(d.Descuentos).format(
                                                    '0,0.[00]'
                                                )
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right" colspan="6">
                                            Cargos
                                        </td>
                                        <td class="text-right" colspan="4">
                                            {{ d.TipoMoneda }}
                                            {{
                                                numeral(d.Cargos).format(
                                                    '0,0.[00]'
                                                )
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right" colspan="6">
                                            Imp. Especifico
                                        </td>
                                        <td class="text-right" colspan="4">
                                            {{ d.TipoMoneda }}
                                            {{
                                                numeral(d.Impuestos).format(
                                                    '0,0.[00]'
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td class="text-right" colspan="6">
                                            Total OC
                                        </td>
                                        <td class="text-right" colspan="4">
                                            {{ d.TipoMoneda }}
                                            {{
                                                numeral(d.Total).format(
                                                    '0,0.[00]'
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </template>
                </template>
            </div>
        </el-dialog>
    </div>
</template>
<style lang="scss">
.expenses-detail-visualization {
    .disclaimer {
        font-size: 10px;
    }
}
</style>
<script>
import axios from 'axios';
import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import rutFormatter from '../../Methods/RutFormatter';

export default {
    data: function() {
        return {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            total: 0,
            search: '',
            orderBy: null,
            data: [],
            dialogVisible: false,
            dialogOCId: null,
            dialogOC: null,
            dialogOCError: null,
            dialogOCLoading: false
        };
    },
    props: ['where', 'height'],
    methods: {
        moment: moment,
        numeral: numeral,
        rutFormatter: rutFormatter,
        hideRUT: function(string) {
            return string.replace(
                /r.?u.?(t|n).? (\d|\.|\-)+/gi,
                '(RUN Anonimizado)'
            );
        },
        refreshData: function() {
            //console.log('refresh');

            this.loading = true;
            Promise.all([
                axios
                    .post('/api/v1/data/pagos', {
                        where: JSON.stringify(this.where),
                        search: JSON.stringify(
                            this.search ? this.search + '*' : null
                        ),
                        limit: this.pageSize,
                        offset: (this.currentPage - 1) * this.pageSize,
                        'order-by': JSON.stringify(this.orderBy)
                    })
                    .then(response => {
                        //this.loading = false;
                        this.data = response.data;
                    }),
                axios
                    .post('/api/v1/data/pagos', {
                        where: JSON.stringify(this.where),
                        search: JSON.stringify(
                            this.search ? this.search + '*' : null
                        ),
                        count: true
                    })
                    .then(response => {
                        //this.loading = false;
                        this.total = response.data[0].count;
                    })
            ]).then(() => {
                this.loading = false;
            });
        },
        debouncedRefreshData: _.debounce(function() {
            this.refreshData();
        }, 1000),
        sortChange: function(a) {
            if (a.prop === null) this.orderBy = null;
            else
                this.orderBy = [
                    a.prop,
                    a.order === 'ascending' ? 'asc' : 'desc'
                ];
        },
        openOC: function(id) {
            this.dialogOCId = id;
            this.dialogVisible = true;
        },
        formatCurrency(string) {
            if (string === 'PESOS') return '';
            else if (string === 'DOLARES') return 'USD';
            else return string;
        },
        checkOC(string) {
            if (!string) return false;

            return string.match(/^\d+-\d+-\w{2}\d{2}$/);
        },
        isFloatingDebt(data) {
            const currentYear = 1 * process.env.MIX_DEFAULT_YEAR;
            return data.periodo < currentYear && data.fecha_pago === null;
        }
    },
    computed: {
        downloadURL: function() {
            return (
                '/api/v1/data/pagos?pagination-page=1&where=' +
                JSON.stringify(this.where)
            );
        }
    },
    watch: {
        currentPage: function(value) {
            //console.log('currentPage', value);
            this.refreshData();
        },
        orderBy: function(value) {
            //console.log('orderBy',value);
            this.refreshData();
        },
        where: function(value) {
            //console.log('where', value);
            this.refreshData();
        },
        search: function(value) {
            //console.log('search', value)
            this.debouncedRefreshData();
        },
        dialogOCId: function(dialogOCId) {
            this.dialogOC = null;
            this.dialogOCLoading = true;
            axios
                .get(
                    'https://api.mercadopublico.cl/servicios/v1/publico/OrdenesDeCompra.json',
                    {
                        params: {
                            codigo: dialogOCId,
                            ticket: '6B1A0A9C-ED05-4DF1-A82F-2356CB4DDE07'
                        }
                    }
                )
                .then(response => {
                    this.dialogOCLoading = false;
                    this.dialogOCError = null;
                    this.dialogOC = response.data;
                })
                .catch(err => {
                    this.dialogOCLoading = false;
                    //this.dialogOCError = _.get(err, 'response.data.Mensaje', err.message);
                    this.dialogOCError =
                        'El número de orden de compra ingresado por la institución no corresponde al formato requerido para identificar una orden de compra en la Dirección de Compras Públicas.';
                });
        }
    },
    mounted: function() {
        //console.log('mount');
        //this.refreshData();
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/ExpensesDetail.vue